// extracted by extract-css-chunks-webpack-plugin
module.exports = {"products":"Products__products","products_headline":"Products__products_headline","products_link":"Products__products_link"};